/* eslint-disable formatjs/enforce-default-message */
import React, { useState } from 'react'
import {
  Link as MUILink,
  Button,
  Checkbox,
  FormControlLabel,
  TableContainer,
  Grid,
} from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import IconButton from '@material-ui/core/IconButton'
import { makeStyles, Theme } from '@material-ui/core/styles'
import clsx from 'clsx'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from '../../../messages'
import DeleteAllDialog from '@src/routes/Configurators/components/DeleteDialog'
import { standardTubeRoute, useRouter } from '@src/routes'
import { ActiveLinkType, TubeProperties, TubeProduct } from '../enum'
import { configContext } from '../../../utils/StandardReducer'
import ValidationErrors from '../../../validations/ValidationErrors'

import {
  useSessionFieldsMutation,
  useTubeTotalValidationMutation,
  useTubePriceCallMutation,
} from '@src/mutations/ConfiguratorTubesMutation.generated'
import ErrorAlert from '@src/routes/Configurators/components/ErrorAlert'
import { checkValidKey, getMaxId } from '@src/routes/Configurators/utils/util'
import styles from '@src/routes/Configurators/utils/styles'
import OligoNameWarning from '@src/routes/Configurators/validations/oligoNameWarning'

const useStyles = makeStyles((theme: Theme) => {
  return {
    cardWrapper: {
      backgroundColor: 'white',
      padding: theme.spacing(4, 5),
      marginBottom: theme.spacing(4),
      borderRadius: 0,
      boxShadow: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)',
    },
    table: {
      backgroundColor: 'white',
    },
    clearButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
    },
    subHead: {
      fontSize: theme.typography.pxToRem(20),
      fontWeight: theme.typography.fontWeightBold,
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      margin: theme.spacing(3, 0),
    },
    dFlex: {
      display: 'flex',
    },
    dFlexForZHLang: {
      display: 'flex',
      paddingRight: theme.spacing(4.25),
    },
    cardContent: {
      padding: theme.spacing(0),
    },
    deleteMargin: {
      marginLeft: theme.spacing(-1),
      marginRight: theme.spacing(3),
    },
    label: {
      fontWeight: 'bold',
    },
    title: {
      backgroundColor: theme.palette.rich.red,
      color: theme.palette.common.white,
      fontWeight: 'bold',
    },
    deleteButton: {
      padding: theme.spacing(0),
    },
    deleteAllText: {
      fontSize: theme.typography.pxToRem(16),
      padding: theme.spacing(1),
    },
    sequenceInfo: {
      fontSize: theme.typography.pxToRem(16),
    },
    alignRight: {
      textAlign: 'right',
    },
    rootRow: {
      fontWeight: theme.typography.fontWeightMedium,
    },
    seqWordWrap: {
      width: 290,
      wordBreak: 'break-all',
    },
    delPopup: {
      height: 0,
    },
    sequenceProperties: {
      width: '31%',
      '& + td': {
        paddingLeft: theme.spacing(1),
      },
      labelRoot: {
        fontSize: theme.typography.pxToRem(16),
        color: theme.palette.grey[500],
      },
      activeLabel: {},
    },
    pt20: {
      paddingTop: theme.spacing(5),
    },
    errorRow: {
      '& th': {
        borderLeft: `5px solid ${theme.palette.rich.red}`,
        paddingLeft: theme.spacing(4),
        borderBottom: '0 none',
      },
      '& td': {
        borderBottom: '0 none',
        padding: theme.spacing(0),
      },
    },
    warningRow: {
      '& th': {
        borderLeft: '5px solid #F7A703',
        paddingLeft: theme.spacing(4),
        borderBottom: '0 none',
      },
      '& td': {
        borderBottom: '0 none',
        padding: theme.spacing(0),
      },
    },
    successRow: {
      '& th': {
        borderBottom: '0 none',
        padding: theme.spacing(4),
      },
      '& td': {
        borderBottom: '0 none',
        padding: theme.spacing(0),
      },
    },
    errorMsgRow: {
      paddingLeft: theme.spacing(10),
    },
    errorText: {
      color: theme.palette.error.main,
      display: 'inline-block',
      '& + div': {
        display: 'inline-block',
      },
    },
    warningColor: {
      color: '#F7A703',
      fontSize: theme.typography.pxToRem(13),
    },
    warningText: {
      color: '#F7A703',
      display: 'inline-block',
      '& + div': {
        display: 'inline-block',
      },
    },
    topRow: {
      display: 'table',
      width: '100%',
    },
    topRowCell: {
      display: 'table-cell',
    },
    closeImg: {
      cursor: 'pointer',
      float: 'right',
      marginTop: '2px',
      width: '25px',
    },
    resetBorderBottom: {
      borderBottom: '0 none',
      padding: '0px',
    },
    name: {
      color: '#07a',
      fontWeight: theme.typography.fontWeightMedium,
      cursor: 'pointer',
    },
    continue: {
      float: 'right',
      paddingLeft: theme.spacing(10),
      paddingRight: theme.spacing(10),
      marginTop: theme.spacing(4),
      marginLeft: theme.spacing(4),
      marginRight: theme.spacing(4),
    },
    addOligoButton: {
      float: 'left',
      paddingLeft: theme.spacing(10),
      paddingRight: theme.spacing(10),
      marginTop: theme.spacing(4),
      marginLeft: theme.spacing(4),
      marginRight: theme.spacing(4),
    },
    seqHeadText: {
      paddingLeft: theme.spacing(0),
    },
    wordWrapName: {
      width: theme.spacing(60),
      wordBreak: 'break-all',
      marginBottom: theme.spacing(3),
    },
    override: {
      fontSize: theme.typography.pxToRem(14),
      color: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightMedium,
      marginTop: theme.spacing(-2),
    },
    margin: {
      marginTop: theme.spacing(-2),
    },
    tableContainer: {
      maxHeight: 927,
    },
    deleteIcon: {
      fontSize: theme.typography.pxToRem(22),
      color: theme.palette.grey[400],
    },
  }
})

export interface Data {
  id: number
  name: string
  base: string
  price: string
  scale: string
  purification: string
}

let data

export function performDelete(obj) {
  const array = data
  const index = array.indexOf(obj)
  if (index !== -1) {
    array.splice(index, 1)
    data = [...array]
  }
}

const ReviewDialog = (props) => {
  // This param is use to set CSS
  const classes = useStyles()
  const GlobalCSS = styles()
  const { state, dispatch } = React.useContext(configContext)
  const [delItem, setDelItem] = useState()
  const [delType, setDelType] = useState('')
  const [delDialogOpen, setDelDialogOpen] = useState(false)
  const [sessionFields] = useSessionFieldsMutation()
  const router = useRouter()
  const intl = useIntl()
  const { productDetails, setItemDetails } = props
  const maxItems =
    productDetails.productType === TubeProduct.iscaledna
      ? TubeProperties.MaximumOligosAllowedIscaledna
      : TubeProperties.MaximumOligosAllowed
  const sequencePath = `${standardTubeRoute.index()}?product=${
    productDetails.productType
  }&activeLink=${ActiveLinkType.SequenceEntry}`
  const { sessionData, OligoIndex, countryCode, currentOligoIndex } = state
  const orderPath = `${standardTubeRoute.index()}?product=${
    productDetails.productType
  }&activeLink=${ActiveLinkType.ConfirmOrder}`
  const [tubePriceCall] = useTubePriceCallMutation()
  const [tubeTotalValidation] = useTubeTotalValidationMutation()
  const [isErrorMsg, setIsErrorMsg] = useState(false)
  const [open, setOpen] = useState(false)
  const [isDelete, setIsDelete] = useState(false)
  const [scrollBar, setScrollBar] = useState(false)
  const multiplePath = `${standardTubeRoute.index()}?product=${
    productDetails.productType
  }&activeLink=${ActiveLinkType.MultipleEntry}`
  const [errorMsg, setErrorMsg] = useState(
    intl.formatMessage(messages.REVIEW_PAGE_ERROR_HEADER_MESSAGE)
  )

  const [isCurrentOligoIndexChanged, setIsCurrentOligoIndexChanged] =
    React.useState<boolean>(false)
  const [isNameWarning, setIsNameWarning] = React.useState(false)
  const setInitialState = () => {
    return {
      additionalCarrierProtein: 'None',
      additionalComments: '',
      additionalServices: [],
      amount: '',
      applyToAll: false,
      autoValidation: '',
      baseCount: 0,
      carrierProtein: '',
      cartId: '',
      comments: '',
      concentration: '',
      conjugation: 'None',
      conjugationAmount: '',
      conjugationChemistry: '',
      countryCode: 'countryCode',
      crossContamination: '',
      crRnaType: '',
      cterminalMod: '',
      currency: '',
      currencySymbol: '',
      customPeptideType: '',
      epsilon: 0,
      fiveMod: '',
      fiveModCategory: '',
      flag: 0,
      format: 'DRY',
      fullSOligoBackbone: false,
      gcContent: '',
      id: (state.oligoCount + 1).toString(),
      internalModCategory: '',
      isLabelledAminoAcid: true,
      isoCode: false,
      isOverridden: false,
      itemId: '',
      listError: [
        {
          key: '',
          value: '',
        },
      ],
      material: '',
      meltingTemparature: '',
      minimumYield: '',
      molecularWeight: '',
      name: '',
      nterminalMod: '',
      oligoId: state.oligoCount + 1,
      orderItemId: '',
      otherValue: '',
      packageType: '',
      plateType: '',
      price: '',
      primerDimer: '',
      productType: productDetails.productType,
      purification: '',
      purityLevel: '',
      quantitation: '',
      scale: '',
      secondaryStructure: '',
      sequence: '',
      sequenceLocation: '',
      threeMod: '',
      threeModCategory: '',
      tubes: '1',
    }
  }
  const [isOverride, setIsOverride] = React.useState<any>({
    checked: false,
  })
  let deleteLast = false
  const sessionDataToSession = async (obj) => {
    if (deleteLast) {
      await sessionFields({
        variables: { input: [], productInput: productDetails },
      })
      deleteLast = false
    } else {
      await sessionFields({
        variables: { input: obj, productInput: productDetails },
      })
    }
  }

  const checkListError = (item) => {
    const sequenceValidation: string[] = []
    const { listError } = item
    if (listError && listError?.length !== 0) {
      listError.forEach((data) => {
        const { key, value } = data

        if (
          key &&
          value &&
          key === messages.CONF_REVIEW_ERROR_MSG.defaultMessage
        ) {
          if (
            value === messages.MINIMUM_SEQUENCE_LENGTH.defaultMessage ||
            value === messages.MINIMUM_SEQUENCE_LENGTH_JA.defaultMessage
          ) {
            sequenceValidation.push(
              intl.formatMessage(messages.MINIMUM_SEQUENCE_LENGTH)
            )
          } else if (
            value === messages.MAXIMUM_SEQUENCE_LENGTH.defaultMessage ||
            value === messages.MAXIMUM_SEQUENCE_LENGTH_JA.defaultMessage
          ) {
            sequenceValidation.push(
              intl.formatMessage(messages.MAXIMUM_SEQUENCE_LENGTH)
            )
          } else {
            sequenceValidation.push(value)
          }
        }
      })
    }
    return sequenceValidation
  }

  const CheckReviewWarning = (item) => {
    const { listWarning } = item
    const reviewWarning: string[] = []
    if (listWarning && listWarning.length !== 0) {
      listWarning.forEach((warning) => {
        const { key, value } = warning
        if (key === TubeProperties.ReviewWarning) {
          reviewWarning.push(value)
        }
      })
    }
    return reviewWarning
  }
  // This method is use to perform delete and delete all operations
  const deleteOligoItem = (item, type) => {
    let isDeleteAll = false
    if (type === 'Selected' || type === 'SelectedViewAll') {
      if (OligoIndex !== 0) {
        const newIndex = OligoIndex - 1
        const array = [...state.sessionData]
        const index = array.indexOf(item)
        if (index !== -1) {
          array.splice(index, 1)
        }

        dispatch({
          type: 'UPDATE_OLIGO_INDEX',
          data: newIndex,
        })
        dispatch({
          type: 'UPDATE_CURRENT_OLIGO_INDEX',
          data: newIndex,
        })
        dispatch({
          type: 'UPDATE_INPUT',
          data: array,
        })
        setIsDelete(true)
        if (array) {
          array.forEach((item, index) => {
            if (item.listError) {
              item.listError.forEach((element) => {
                delete element.__typename
                array[index].listError = item.listError
              })
            }
          })
        }
        sessionDataToSession(array)
      } else {
        isDeleteAll = true
      }
    } else if (type === 'All') {
      isDeleteAll = true
    }

    if (isDeleteAll) {
      deleteLast = true
      dispatch({ type: 'IS_DELETE_ALL', data: true })
      dispatch({
        type: 'UPDATE_OLIGO_INDEX',
        data: 0,
      })
      dispatch({
        type: 'UPDATE_CURRENT_OLIGO_INDEX',
        data: 0,
      })
      dispatch({
        type: 'IS_COMING_FROM_REVIEW_PAGE',
        data: false,
      })
      dispatch({
        type: 'IS_CONCENTRATION_ENABLE',
        data: false,
      })
      dispatch({
        type: 'CALL_SESSION_API',
        data: true,
      })
      dispatch({ type: 'IS_TUBE_PAGE_LOAD', data: false })
      dispatch({ type: 'FOCUS_ON_SEQUENCEBOX', data: false })
      dispatch({ type: 'UPDATE_OPTIONAL_BASES', data: '' })
      dispatch({ type: 'UPDATE_AQUA_INTERNAL_MOD', data: '' })
      router.push(sequencePath)
      dispatch({
        type: 'UPDATE_INPUT',
        data: [setInitialState()],
      })
      dispatch({
        type: 'IS_LABEL_AMINO_ACID_ERROR',
        data: false,
      })
      dispatch({
        type: 'UPDATE_ERROR_DATA',
        data: {
          ...state.errorData,
          name: '',
          sequence: '',
          scale: '',
          purification: '',
          fiveMod: '',
          threeMod: '',
          researcher: '',
          format: 'DRY',
          concentration: '',
          tubes: '1',
          countryCode: countryCode,
          fullSOligoBackbone: false,
          isOverridden: false,
          comments: '',
          cterminalMod: '',
          nterminalMod: '',
          otherValue: '',
          isLabelledAminoAcid: true,
          quantitation: '',
          purityLevel: '',
          amount: '',
          conjugation: '',
          conjugationAmount: '',
          conjugationChemistry: '',
          additionalCarrierProtein: '',
          additionalServices: [],
          flag: 0,
        },
      })

      dispatch({
        type: 'UPDATE_PAGE_LOAD',
        data: 1,
      })
      sessionDataToSession([setInitialState()])
    }
    if (state.sessionData.length <= 10) {
      setScrollBar(false)
    }

    if (
      errorMsg.includes(
        intl.formatMessage(messages.CONF_MAX_ITEMS_ALLOWED, { maxItems })
      )
    ) {
      setErrorMsg('')
      let isInvalidData = true
      sessionData.forEach((item) => {
        if (item.listError.length > 0 && isInvalidData) {
          setErrorMsg(
            intl.formatMessage(messages.REVIEW_PAGE_ERROR_HEADER_MESSAGE)
          )
          isInvalidData = false
        }
      })
    }
  }

  const addOligo = () => {
    const newIndex = sessionData.length
    dispatch({
      type: 'UPDATE_OLIGO_INDEX',
      data: newIndex,
    })
    dispatch({
      type: 'UPDATE_CURRENT_OLIGO_INDEX',
      data: newIndex,
    })
    const emptyStateObj = Object.assign({}, setInitialState())
    state.sessionData.push(emptyStateObj)
    dispatch({ type: 'IS_TUBE_PAGE_LOAD', data: false })
    dispatch({
      type: 'UPDATE_ERROR_DATA',
      data: {
        ...state.errorData,
        name: '',
        sequence: '',
        scale: '',
        purification: '',
        fiveMod: '',
        threeMod: '',
        researcher: '',
        format: 'DRY',
        concentration: '',
        tubes: '1',
        countryCode: countryCode,
        fullSOligoBackbone: false,
        isOverridden: false,
        comments: '',
        cterminalMod: '',
        nterminalMod: '',
        otherValue: '',
        isLabelledAminoAcid: true,
        quantitation: '',
        purityLevel: '',
        amount: '',
        conjugation: 'None',
        conjugationAmount: '',
        conjugationChemistry: '',
        additionalCarrierProtein: 'None',
        additionalServices: [],
        flag: 0,
      },
    })
    dispatch({
      type: 'UPDATE_INPUT',
      data: [...state.sessionData],
    })

    dispatch({
      type: 'UPDATE_PAGE_LOAD',
      data: 1,
    })
  }

  const handleDelete = (item) => {
    setDelDialogOpen(true)
    setDelType('Selected')
    setDelItem(item)
  }

  const displaySessionData = (index) => {
    setIsCurrentOligoIndexChanged(true)
    dispatch({
      type: 'UPDATE_CURRENT_OLIGO_INDEX',
      data: index,
    })
    dispatch({
      type: 'UPDATE_PAGE_LOAD',
      data: 1,
    })
    dispatch({
      type: 'IS_COMING_FROM_REVIEW_PAGE',
      data: true,
    })
    dispatch({
      type: 'IS_CONCENTRATION_ENABLE',
      data: true,
    })
  }

  const priceCall = async (num) => {
    if (sessionData) {
      sessionData.forEach((item, index) => {
        if (item.listError) {
          item.listError.forEach((element) => {
            delete element.__typename
          })
          sessionData[index].listError = item.listError
        }
      })
    }
    const response: any = await tubePriceCall({
      variables: { input: sessionData, productInput: productDetails },
    })

    if (response) {
      const error: any[] = []
      setItemDetails(response.data.tubePriceCall.result)
      response.data.tubePriceCall.result.forEach((resp) => {
        resp.listErrors.forEach((item) => {
          delete item.__typename
        })
        error.push(resp.listErrors)
      })
      dispatch({ type: 'UPDATE_TOTALVALIDATION', data: error })
      let isValidData = true
      response.data.tubePriceCall.result.forEach((item, index) => {
        if (item.listErrors.length !== 0) {
          isValidData = false
        } else {
          sessionData[index].price = item.price
          sessionData[index].currencySymbol = item.currencySymbol
          sessionData[index].currency = item.currency
        }
      })

      if (isValidData) {
        dispatch({ type: 'IS_BULK_REVIEW', data: false })
        if (num === 1) {
          dispatch({ type: 'IS_CONFIRM_ORDER', data: true })
          dispatch({ type: 'SET_STEP_NO', data: 1 })
          dispatch({
            type: 'ON_CONTINUE_BUTTON_PRICECALL',
            data: true,
          })
          dispatch({ type: 'IS_COMING_FROM_CONFIRM_PAGE', data: true })
          router.push(orderPath)
        } else {
          addOligo()
          router.push(sequencePath)
          dispatch({ type: 'SET_STEP_NO', data: 0 })
          dispatch({ type: 'IS_CONFIRM_ORDER', data: false })
        }

        dispatch({ type: 'IS_DISPLAY_ERROR', data: false })
      } else {
        dispatch({ type: 'SET_STEP_NO', data: 0 })
      }
      dispatch({
        type: 'UPDATE_INPUT',
        data: [...sessionData],
      })

      if (state.totalValidationJSON.length !== 0) {
        dispatch({ type: 'SPECIFICATION_TOTAL_VALIDATION', data: true })
      }
    }
    window.scrollTo(0, 0)
  }
  const handleClick = () => {
    priceCall(1)
  }
  const handleAddOligo = () => {
    if (
      sessionData.length <
      (productDetails.productType === TubeProduct.iscaledna
        ? TubeProperties.MaximumOligosAllowedIscaledna
        : TubeProperties.MaximumOligosAllowed)
    ) {
      priceCall(2)
    } else {
      setOpen(true)
      setErrorMsg(
        intl.formatMessage(messages.CONF_MAX_ITEMS_ALLOWED, { maxItems })
      )
      window.scrollTo(0, 0)
    }
  }
  const handlePrevious = () => {
    dispatch({
      type: 'UPDATE_CURRENT_OLIGO_INDEX',
      data: 0,
    })
    dispatch({ type: 'IS_BULK_REVIEW', data: false })
    router.push(multiplePath)

    dispatch({
      type: 'UPDATE_ERROR_DATA',
      data: {
        ...state.errorData,
        name: '',
        sequence: '',
        scale: '',
        purification: '',
        fiveMod: '',
        threeMod: '',
        researcher: '',
        format: 'DRY',
        concentration: '',
        tubes: '1',
        countryCode: countryCode,
        fullSOligoBackbone: false,
        isOverridden: false,
        comments: '',
        cterminalMod: '',
        nterminalMod: '',
        otherValue: '',
        amount: '',
        purityLevel: '',
        quantitation: '',
        isLabelledAminoAcid: true,
        conjugation: 'None',
        conjugationAmount: '',
        conjugationChemistry: '',
        additionalCarrierProtein: 'None',
        additionalServices: [],
        flag: 0,
      },
    })

    dispatch({
      type: 'UPDATE_PAGE_LOAD',
      data: 1,
    })
    window.scrollTo(0, 0)
  }

  const setErrorData = (data) => {
    dispatch({
      type: 'UPDATE_ERROR_DATA',
      data: {
        ...state.errorData,
        name: data.name,
        sequence: data.sequence,
        threeMod: data.threeMod || '',
        fiveMod: data.fiveMod || '',
        scale: data.scale,
        purification: data.purification,
        format: data.format,
        concentration: data.concentration,
        tubes: data.tubes,
        fullSOligoBackbone: data.fullSOligoBackbone,
        isOverridden: data.isOverridden,
        comments: data.comments,
        cterminalMod: data.cterminalMod,
        nterminalMod: data.nterminalMod,
        otherValue: '',
        isLabelledAminoAcid: data.isLabelledAminoAcid,
        quantitation: data.quantitation,
        purityLevel: data.purityLevel,
        amount: data.amount,
        conjugation: data.conjugation,
        conjugationAmount: data.conjugationAmount,
        conjugationChemistry: data.conjugationChemistry,
        additionalCarrierProtein: data.additionalCarrierProtein,
        additionalServices: data.additionalServices,
        flag: data.flag,
      },
    })
  }

  React.useEffect(() => {
    if (isDelete) {
      let isListErrorRemaning = false
      sessionData.forEach((data) => {
        if (
          data.listError &&
          !isListErrorRemaning &&
          data.listError?.length !== 0
        ) {
          isListErrorRemaning = true
        }
      })
      setIsErrorMsg(isListErrorRemaning)
      setOpen(isListErrorRemaning)
      setIsDelete(false)
    }
    if (sessionData && sessionData.length !== 0) {
      let warning = false
      sessionData.forEach((data) => {
        if (data.name && data.name.length > 18 && warning !== true) {
          warning = true
        }
      })
      setIsNameWarning(warning)
    }
    // TODO: need a test before we refactor these dependencies
  }, [sessionData])

  React.useEffect(() => {
    if (
      state.isPageLoad === 1 &&
      sessionData !== null &&
      sessionData.length !== 0 &&
      sessionData[state.currentOligoIndex] !== null &&
      Object.keys(sessionData[state.currentOligoIndex]).length !== 0
    ) {
      if (
        sessionData[currentOligoIndex].isOverridden !== null &&
        sessionData[currentOligoIndex].isOverridden !== undefined
      ) {
        const data: any = sessionData[currentOligoIndex].isOverridden
        setIsOverride({
          ...isOverride,
          checked: data,
        })
      }
      setErrorData(sessionData[state.currentOligoIndex])
    }
    // TODO: need a test before we refactor these dependencies
  }, [state.isPageLoad])

  React.useEffect(() => {
    let isListErrorRemaning = false
    sessionData.forEach((data) => {
      if (
        data.listError &&
        !isListErrorRemaning &&
        data.listError?.length !== 0
      ) {
        isListErrorRemaning = true
      }
    })
    setIsErrorMsg(isListErrorRemaning)
    setOpen(isListErrorRemaning)

    // TODO: need a test before we refactor these dependencies
  }, [sessionData])

  const totalValidation = async () => {
    sessionData[currentOligoIndex].isLabelledAminoAcid = true
    if (sessionData) {
      sessionData.forEach((item, index) => {
        if (item.listError) {
          item.listError.forEach((element) => {
            delete element.__typename
          })
          sessionData[index].listError = item.listError
        }
      })
    }
    const response: any = await tubeTotalValidation({
      variables: { input: sessionData, productInput: productDetails },
    })
    if (response.data) {
      response.data.tubeTotalValidation.forEach((resp) => {
        resp.listErrors.forEach((item) => {
          delete item.__typename
        })
      })
      let isErrorData = false
      response.data.tubeTotalValidation.forEach((item, index) => {
        sessionData[index].listError =
          item?.listErrors !== null ? item?.listErrors : null
        if (item.listErrors.length !== 0) {
          isErrorData = true
        }
      })
      setIsErrorMsg(isErrorData)
      setOpen(isErrorData)
      dispatch({
        type: 'UPDATE_INPUT',
        data: [...sessionData],
      })
    }
  }

  const handleIsOverride = (event) => {
    setIsOverride({ ...isOverride, checked: event.target.checked })

    sessionData.forEach((item) => {
      item.isOverridden = event.target.checked
    })
    dispatch({
      type: 'UPDATE_ERROR_DATA',
      data: { ...state.errorData, isOverridden: event.target.checked },
    })
    dispatch({
      type: 'UPDATE_INPUT',
      data: [...state.sessionData],
    })
    totalValidation()

    sessionDataToSession(sessionData)
  }
  React.useEffect(() => {
    const maxId = getMaxId(sessionData)
    dispatch({
      type: 'ADD_NEW_OLIGO',
      data: maxId,
    })

    window.scrollTo(0, 0)
    if (
      sessionData[currentOligoIndex].name?.length &&
      sessionData[currentOligoIndex].sequence?.length
    )
      totalValidation()

    if (state.sessionData.length > 10) {
      setScrollBar(true)
    }
    // TODO: need a test before we refactor these dependencies
  }, [])

  React.useEffect(() => {
    if (state.isTubePageLoad && state.sessionData.length > 10) {
      setScrollBar(true)
    }
    // TODO: need a test before we refactor these dependencies
  }, [state.isTubePageLoad])

  React.useEffect(() => {
    if (isCurrentOligoIndexChanged) {
      setErrorData(sessionData[currentOligoIndex])
      setIsCurrentOligoIndexChanged(false)
      router.push(sequencePath)
    }
  }, [currentOligoIndex, isCurrentOligoIndexChanged])

  // This method is use to render data
  const renderData = () => {
    const result: any[] = []
    let errorMsg: string[] = []
    let warningMsg: string[] = []
    let scale: string
    let amount: string
    let sequence: string

    sessionData.map((item, index) => {
      errorMsg = checkListError(item)
      warningMsg = CheckReviewWarning(item)
      sequence = ''
      scale = ''
      amount = ''
      if (item.scale) {
        scale = item.scale?.replace(/[^a-zA-Z0-9]/g, '_')
      }
      if (item.amount) {
        amount = item.amount?.replace(/[^a-zA-Z0-9]/g, '_')
      }
      if (item.fiveMod) {
        const fiveMod =
          item.fiveMod?.replace(/[[\]]/g, '') !== TubeProperties.None
            ? item.fiveMod
            : ''
        sequence = fiveMod
      }
      if (item.sequence) {
        sequence = sequence + item.sequence
      }
      if (item.threeMod) {
        const threeMod =
          item.threeMod?.replace(/[[\]]/g, '') !== TubeProperties.None
            ? item.threeMod
            : ''
        sequence = sequence + threeMod
      }
      if (productDetails.productType === TubeProduct.Aqua) {
        if (item.nterminalMod) {
          sequence = `${item.nterminalMod}${sequence}`
        }
        if (item.cterminalMod) {
          sequence = `${sequence}${item.cterminalMod}`
        }
      }
      result.push(
        <TableRow
          key={index}
          className={
            errorMsg.length !== 0
              ? classes.errorRow
              : warningMsg.length !== 0
                ? classes.warningRow
                : classes.successRow
          }
        >
          <TableCell
            component="th"
            scope="row"
            className={classes.wordWrapName}
          >
            <MUILink
              underline="hover"
              className={classes.name}
              onClick={() => displaySessionData(index)}
            >
              {item.name?.length !== 0 ? item.name : '--'}
            </MUILink>
          </TableCell>
          <TableCell align="left" className={clsx(classes.seqWordWrap)}>
            {item.sequence?.length !== 0 ? sequence : '--'}
          </TableCell>
          <TableCell align="center">
            {item.baseCount !== 0 ? item.baseCount : '--'}
          </TableCell>
          {productDetails.productType === TubeProperties.EasyOligo ||
          productDetails.productType === TubeProduct.Probe ||
          productDetails.productType === TubeProduct.Aqua ||
          productDetails.productType === TubeProduct.Beacon ||
          productDetails.productType === TubeProduct.Wellred ||
          productDetails.productType === TubeProduct.iscaledna ||
          productDetails.productType === TubeProduct.LongOligo ||
          productDetails.productType === TubeProduct.PureSimple ||
          productDetails.productType === TubeProduct.Cpeptide ? (
            ''
          ) : (
            <TableCell align="center">
              {scale?.length !== 0 ? (
                <FormattedMessage
                  {...checkValidKey(
                    messages[`_PC_SPEC_${scale}`],
                    `_PC_SPEC_${scale}`
                  )}
                />
              ) : (
                '--'
              )}
            </TableCell>
          )}

          {productDetails.productType === TubeProduct.Probe ||
          productDetails.productType === TubeProduct.Beacon ||
          productDetails.productType === TubeProduct.Wellred ||
          productDetails.productType === TubeProduct.iscaledna ||
          productDetails.productType === TubeProduct.LongOligo ? (
            <TableCell align="center">
              {item.amount?.length !== 0 ? item.amount : '--'}
            </TableCell>
          ) : (
            ''
          )}

          {productDetails.productType === TubeProduct.Aqua ||
          productDetails.productType === TubeProduct.Cpeptide ? (
            <TableCell align="center">
              {amount?.length !== 0 ? (
                <FormattedMessage
                  {...checkValidKey(
                    messages[`_PC_SPEC_${amount}`],
                    `_PC_SPEC_${amount}`
                  )}
                />
              ) : (
                '--'
              )}
            </TableCell>
          ) : (
            ''
          )}

          {productDetails.productType !== TubeProperties.EasyOligo &&
          productDetails.productType !== TubeProduct.PureSimple ? (
            <>
              <TableCell align="center">
                {productDetails.productType === TubeProduct.Aqua ||
                productDetails.productType === TubeProduct.Cpeptide ? (
                  item.purityLevel?.length !== 0 ? (
                    <>
                      {productDetails.productType !== TubeProduct.Cpeptide ? (
                        <FormattedMessage
                          {...checkValidKey(
                            messages[`_PC_SPEC_${item.purityLevel}`],
                            `_PC_SPEC_${item.purityLevel}`
                          )}
                        />
                      ) : (
                        <FormattedMessage
                          {...checkValidKey(
                            messages[`PC_SPEC_${item.purityLevel}`],
                            `PC_SPEC_${item.purityLevel}`
                          )}
                        />
                      )}
                    </>
                  ) : (
                    '--'
                  )
                ) : item.purification?.length !== 0 ? (
                  <FormattedMessage
                    {...checkValidKey(
                      messages[`_PC_SPEC_${item.purification}`],
                      `_PC_SPEC_${item.purification}`
                    )}
                  />
                ) : (
                  '--'
                )}
              </TableCell>
            </>
          ) : (
            ''
          )}
          {productDetails.productType === TubeProduct.iscaledna ? (
            item.additionalServices && item.additionalServices?.length !== 0 ? (
              <TableCell align="center">
                {item.additionalServices.map((service, index) => {
                  return (
                    <tr key={service}>
                      <td>
                        {index === item.additionalServices.length - 1 ? (
                          <FormattedMessage
                            {...checkValidKey(
                              messages[`_PC_SPEC_${service}`],
                              `_PC_SPEC_${service}`
                            )}
                          />
                        ) : (
                          // eslint-disable-next-line formatjs/enforce-id
                          intl.formatMessage({
                            ...checkValidKey(
                              messages[`_PC_SPEC_${service}`],
                              `_PC_SPEC_${service}`
                            ),
                          }) + ','
                        )}
                      </td>
                    </tr>
                  )
                })}
              </TableCell>
            ) : (
              <TableCell align="center"> {'--'} </TableCell>
            )
          ) : (
            ''
          )}
          <TableCell align="right">
            <IconButton
              aria-label="delete"
              onClick={() => {
                handleDelete(item)
              }}
            >
              <DeleteIcon className={classes.deleteIcon} />
            </IconButton>
          </TableCell>
        </TableRow>,
        <TableRow>
          <TableCell className={classes.errorMsgRow} colSpan={6}>
            {errorMsg.length !== 0 ? (
              <div>
                <div className={classes.errorText}>
                  <FormattedMessage {...messages.CONF_ERROR} />
                </div>
                <ValidationErrors errors={errorMsg} />
              </div>
            ) : (
              ''
            )}
            {warningMsg.length !== 0 ? (
              <div className={classes.warningColor}>
                <div className={classes.warningText}>
                  <FormattedMessage {...messages.CONF_PRICE_WARNING} />
                </div>{' '}
                {warningMsg}
              </div>
            ) : (
              ''
            )}
          </TableCell>
        </TableRow>
      )
      return true
    })
    return result
  }

  return (
    <>
      {isErrorMsg ? (
        <ErrorAlert open={open} setOpen={setOpen} message={errorMsg} />
      ) : (
        ''
      )}
      {isNameWarning ? (
        <Grid className={GlobalCSS.warningBox}>
          <OligoNameWarning
            warning={intl.formatMessage(messages.CONF_OLIGO_NAME_WARNING)}
          />
        </Grid>
      ) : (
        ''
      )}
      <div className={classes.header}>
        <h3 className={classes.subHead}>
          <strong>
            <FormattedMessage {...messages.CONF_SEQUENCE_ENTRY} />
          </strong>
        </h3>

        <div className={scrollBar ? classes.dFlexForZHLang : classes.dFlex}>
          {productDetails.isCSRSupervisor ? (
            <FormControlLabel
              classes={{ label: classes.override }}
              control={
                <Checkbox
                  color="primary"
                  className={classes.margin}
                  value={messages.CONF_OVERRIDE_VALIDATION.defaultMessage}
                />
              }
              label={messages.CONF_OVERRIDE_VALIDATION.defaultMessage}
              onChange={handleIsOverride}
              checked={isOverride.checked}
            />
          ) : (
            ''
          )}

          <h4>
            <strong className={classes.deleteAllText}>
              <FormattedMessage {...messages.CONF_DELETE_ALL_BUTTON} />
            </strong>
          </h4>
          <span className={classes.deleteMargin}>
            <IconButton
              aria-label="delete"
              className={classes.deleteButton}
              onClick={() => {
                setDelDialogOpen(true)
                setDelType('All')
                setDelItem(delItem)
              }}
            >
              <DeleteIcon className={classes.deleteIcon} />
            </IconButton>
          </span>
        </div>
      </div>
      <TableContainer className={scrollBar ? classes.tableContainer : ''}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell align="left" className={classes.rootRow}>
                {productDetails.productType === TubeProduct.Aqua ||
                productDetails.productType === TubeProduct.Cpeptide ? (
                  <FormattedMessage {...messages.PEPTIDE_NAME} />
                ) : (
                  <FormattedMessage {...messages.NAME} />
                )}
              </TableCell>
              <TableCell
                align="left"
                className={clsx(classes.rootRow, classes.seqHeadText)}
              >
                <FormattedMessage {...messages.CONF_SEQUENCE_LABEL} />
              </TableCell>
              <TableCell align="center" className={classes.rootRow}>
                #
                {productDetails.productType === TubeProduct.Aqua ||
                productDetails.productType === TubeProduct.Cpeptide ? (
                  <FormattedMessage {...messages.CONF_AMINO_ACIDS} />
                ) : (
                  <FormattedMessage {...messages.CONF_BASES} />
                )}
              </TableCell>
              {productDetails.productType === TubeProperties.EasyOligo ||
              productDetails.productType === TubeProduct.Probe ||
              productDetails.productType === TubeProduct.Aqua ||
              productDetails.productType === TubeProduct.Beacon ||
              productDetails.productType === TubeProduct.Wellred ||
              productDetails.productType === TubeProduct.iscaledna ||
              productDetails.productType === TubeProduct.LongOligo ||
              productDetails.productType === TubeProduct.PureSimple ||
              productDetails.productType === TubeProduct.Cpeptide ? (
                ''
              ) : (
                <TableCell align="center" className={classes.rootRow}>
                  <FormattedMessage {...messages.CONF_SCALE} />
                </TableCell>
              )}
              {productDetails.productType === TubeProduct.Probe ||
              productDetails.productType === TubeProduct.Aqua ||
              productDetails.productType === TubeProduct.Beacon ||
              productDetails.productType === TubeProduct.Wellred ||
              productDetails.productType === TubeProduct.iscaledna ||
              productDetails.productType === TubeProduct.LongOligo ||
              productDetails.productType === TubeProduct.Cpeptide ? (
                <TableCell align="center" className={classes.rootRow}>
                  <FormattedMessage {...messages.CONF_VIEWALL_AMOUNT} />
                </TableCell>
              ) : (
                ''
              )}
              {productDetails.productType !== TubeProperties.EasyOligo &&
              productDetails.productType !== TubeProduct.PureSimple ? (
                <TableCell align="center" className={classes.rootRow}>
                  {productDetails.productType === TubeProduct.Aqua ||
                  productDetails.productType === TubeProduct.Cpeptide ? (
                    <FormattedMessage {...messages._PC_SPEC_PURITY_LEVEL} />
                  ) : (
                    <FormattedMessage {...messages.CONF_PURIFICATION} />
                  )}
                </TableCell>
              ) : (
                ''
              )}
              {productDetails.productType === TubeProduct.iscaledna ? (
                <TableCell align="center" className={classes.rootRow}>
                  <FormattedMessage {...messages.SERVICES} />
                </TableCell>
              ) : (
                ''
              )}
              <TableCell align="left" className={classes.rootRow}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{renderData()}</TableBody>
        </Table>
      </TableContainer>
      <Button
        color="primary"
        variant="contained"
        size="large"
        className={classes.addOligoButton}
        id="2"
        onClick={handleAddOligo}
      >
        {productDetails.productType === TubeProduct.Aqua ? (
          <FormattedMessage {...messages.CONF_ADD_PEPTIDE} />
        ) : (
          <FormattedMessage {...messages.CONF_ADD_OLIGOS} />
        )}
      </Button>

      <Button
        color="primary"
        variant="contained"
        size="large"
        className={classes.continue}
        id="1"
        onClick={handleClick}
      >
        <FormattedMessage {...messages.CONF_AQUA_CONTINUE_BUTTON} />
      </Button>

      <Button
        color="primary"
        variant="contained"
        size="large"
        className={classes.continue}
        onClick={handlePrevious}
      >
        <FormattedMessage {...messages.PREVIOUS_TEXT} />
      </Button>

      <DeleteAllDialog
        dialogOpen={delDialogOpen}
        setDialogOpen={setDelDialogOpen}
        selectedItem={delItem}
        type={delType}
        onDelete={deleteOligoItem}
      />
    </>
  )
}

export default ReviewDialog
